import Vue from "vue";
/**
 * 高德地图定位
 * @type {{}}
 */
export const getLoaction = {
  //获取定位存缓存
  getLocationAddress() {
    return new Promise((resolve, reject) => {
      // 检查缓存中是否有存储的结果
      const cachedResult = localStorage.getItem("locationResult");
      if (cachedResult) {
        resolve(JSON.parse(cachedResult));
      } else {
        //获取当前位置的经纬度
        var data = {
          key: "ROJBZ-A3EH4-K33UM-K6E6D-KUCOJ-AYFKE", //这个key就是你申请的密钥
        };
        var url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
        data.output = "jsonp";
        Vue.prototype
          .$jsonp(url, data)
          .then((res) => {
            if (res.status == 0) {
              // 存储结果到缓存中，设置1小时过期时间
              res.result.ad_info.cityCode =
                String(res.result.ad_info.adcode).substring(0, 4) + "00";
              localStorage.setItem(
                "locationResult",
                JSON.stringify(res.result)
              );
              setTimeout(() => {
                localStorage.removeItem("locationResult");
              }, 3600000); // 1小时 = 3600秒 = 3600000毫秒
              resolve(res.result);
            } else {
              Vue.prototype.$message.error("定位失败，请手动选择位置区域信息!");
              reject("定位失败");
            }
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },

  //获取实时定位
  getRralTimeLocationAddress() {
    return new Promise((resolve, reject) => {
      //获取当前位置的经纬度
      var data = {
        key: "ROJBZ-A3EH4-K33UM-K6E6D-KUCOJ-AYFKE", //这个key就是你申请的密钥
      };
      var url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
      data.output = "jsonp";
      Vue.prototype
        .$jsonp(url, data)
        .then((res) => {
          if (res.status == 0) {
            resolve(res.result);
          } else {
            Vue.prototype.$message.error("定位失败，请手动选择位置区域信息!");
            reject("定位失败");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
